// src/Configuracoes.js

import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';

// Imports dos componentes MUI
import {
  Box, Button, Typography, Paper, TextField, CircularProgress, Divider, InputAdornment
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

const Configuracoes = () => {
  const [horarioCheckin, setHorarioCheckin] = useState('14:00');
  const [horarioCheckout, setHorarioCheckout] = useState('12:00');
  // --- NOVOS ESTADOS PARA A POLÍTICA DE CANCELAMENTO ---
  const [diasAntecedencia, setDiasAntecedencia] = useState(15);
  const [percentualMulta, setPercentualMulta] = useState(20);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchConfiguracoes = async () => {
      setLoading(true);
      try {
        const configRef = doc(db, 'configuracoes', 'gerais');
        const docSnap = await getDoc(configRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setHorarioCheckin(data.checkin || '14:00');
          setHorarioCheckout(data.checkout || '12:00');
          setDiasAntecedencia(data.diasAntecedenciaCancelamento || 15);
          setPercentualMulta(data.percentualMultaAntecedencia || 20);
        }
      } catch (error) {
        toast.error('Erro ao carregar as configurações.');
        console.error("Erro ao buscar configurações: ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchConfiguracoes();
  }, []);

  const handleSalvar = async () => {
    setSaving(true);
    try {
      const configRef = doc(db, 'configuracoes', 'gerais');
      await setDoc(configRef, {
        checkin: horarioCheckin,
        checkout: horarioCheckout,
        diasAntecedenciaCancelamento: Number(diasAntecedencia),
        percentualMultaAntecedencia: Number(percentualMulta),
      }, { merge: true });
      toast.success('Configurações salvas com sucesso!');
    } catch (error) {
      toast.error('Erro ao salvar as configurações.');
      console.error("Erro ao salvar configurações: ", error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: '800px', mx: 'auto' }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" component="h1" fontWeight="600" gutterBottom>
          Configurações Gerais
        </Typography>

        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" gutterBottom>Horários</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Defina os horários padrão para check-in e check-out do sistema.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <TextField
            label="Horário Padrão de Check-in"
            type="time"
            value={horarioCheckin}
            onChange={(e) => setHorarioCheckin(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="Horário Limite de Check-out"
            type="time"
            value={horarioCheckout}
            onChange={(e) => setHorarioCheckout(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Box>

        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" gutterBottom>Política de Cancelamento</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Defina as regras para o cálculo da multa de cancelamento.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
           <TextField
            label="Dias de Antecedência"
            type="number"
            value={diasAntecedencia}
            onChange={(e) => setDiasAntecedencia(e.target.value)}
            helperText="Nº de dias antes do check-in para a multa percentual."
            fullWidth
          />
           <TextField
            label="Percentual da Multa"
            type="number"
            value={percentualMulta}
            onChange={(e) => setPercentualMulta(e.target.value)}
            helperText="Multa para cancelamentos com antecedência."
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            fullWidth
          />
        </Box>
         <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Cancelamentos com menos dias de antecedência do que o definido acima terão como multa o valor de 1 diária.
        </Typography>


        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
            onClick={handleSalvar}
            disabled={saving}
          >
            {saving ? 'Salvando...' : 'Salvar Alterações'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Configuracoes;

